import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupProfileService {

  serverUrl = localStorage.getItem('env') ? localStorage.getItem('env') : environment.serverUrl;

  constructor(private http: HttpClient) { }

  getHeader() {
    const authToken = localStorage.getItem('authToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      })
    };
    return httpOptions;
  }

  getProfileGroups(status = '') {
    if(status) {
      return this.http.get(`${this.serverUrl}/profileGroup/check/${status}`, this.getHeader())
        .pipe(map(response => response));
    } else {
      return this.http.get(`${this.serverUrl}/profileGroup`, this.getHeader())
        .pipe(map(response => response));
    }
  }

  createProfileGroup(grpProfileData) {
    return this.http.post(`${this.serverUrl}/profileGroup`, grpProfileData, this.getHeader())
      .pipe(map(response => response));
  }

  getSingleProfile(grpMatchigId) {
    return this.http.get(`${this.serverUrl}/profileGroup/${grpMatchigId}`, this.getHeader())
      .pipe(map(response => response));
  }

  editGrpProfile(grpProfileData) {
    return this.http.put(`${this.serverUrl}/profileGroup/`, grpProfileData, this.getHeader())
      .pipe(map(response => response));
  }

  deleteGrpProfile(grpMatchigId) {
    return this.http.delete(`${this.serverUrl}/profileGroup/${grpMatchigId}`, this.getHeader())
      .pipe(map(response => response));
  }

  getQrcode(id) {
    return this.http.get(`${this.serverUrl}/profileGroup/QRCode/${id}`, this.getHeader())
      .pipe(map(response => response));
  }

  getQrCodeWithLogo(id, data) {
    return this.http.post(`${this.serverUrl}/profileGroup/QRCode/${id}`, data, this.getHeader())
      .pipe(map(response => response));
  }

  getQrCodeWithCampaign(id, data) {
    return this.http.post(`${this.serverUrl}/profile-group-campaign/${id}`, data, this.getHeader())
      .pipe(map(response => response));
  }

  allowManageGroup() {
    return this.http.post(`${this.serverUrl}/profileGroup/allowManageGroup`, {}, this.getHeader())
      .pipe(map(response => response));
  }

  getProfiles(filter, filteTerms) {
    return this.http.post(`${this.serverUrl}/profileGroup/filter/${filter}`, filteTerms, this.getHeader())
      .pipe(map(response => response));
  }

  getGroupProfileTypeList() {
    return this.http.post(`${this.serverUrl}/profileGroup/getGroupProfileTypeList`, {}, this.getHeader())
      .pipe(map(response => response));
  }

  updateFieldSection(data) {
    this.serverUrl = localStorage.getItem('env') ? localStorage.getItem('env') : environment.serverUrl;
    return this.http.post(`${this.serverUrl}/user/dynamicSearchGroupQR`, data, this.getHeader())
      .pipe(map(response => response));
  }

  getFieldSection() {
    this.serverUrl = localStorage.getItem('env') ? localStorage.getItem('env') : environment.serverUrl;
    return this.http.get(`${this.serverUrl}/user/dynamicSearchGroupQR`, this.getHeader())
      .pipe(map(response => response));
  }
}
